import { BaseInput } from '@/components/BaseInput';
import { ButtonLoading } from '@/components/buttons/ButtonLoading';
import { BaseSelect } from '@/components/BaseSelect';
import BaseDatePicker from '@/components/BaseDatePicker';

import Logic from './logic';
import { IconLeft, IconView } from '../../../../components/Icons';
import { motion } from 'framer-motion';
import { BaseAttachment } from '../../../../components/BaseAttachment';
import { useState } from 'react';
export default function One() {
  const { loading, onSubmit, register, errors } = Logic();
  return (
    <section className="flex justify-center items-center flex-1">
      <form onSubmit={onSubmit} className="max-w-md w-full  rounded p-6 space-y-4">
        <h1 className="mt-10 mb-5 text-slate-800 text-center text-xl font-bold">تسجيل دخول</h1>
        <p className=" text-slate-500 text-center">الرجاء استخدام المعلومات المزودة من الشركة</p>
        <BaseInput
          name="username"
          placeholder="اسم المستخدم"
          register={register}
          error={errors['username']}
        />
        <BaseInput
          name="password"
          placeholder="كلمة المرور"
          type="password"
          register={register}
          error={errors['password']}
        />
        <div className="mt-5">
          {loading ? (
            <ButtonLoading />
          ) : (
            <button
              type="submit"
              className="w-full h-14 rounded-md bg-primary hover:bg-primary-dark  text-sm font-bold text-gray-50 transition duration-200">
              تسجيل الدخول
            </button>
          )}
        </div>
      </form>
    </section>
  );
}
